import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { getTokenValue } from "../../helpers/utility";
import { getUser } from "../../slice/auth/login/thunk";
import { useProfile } from "../Hooks/UseProfile";
import "../../styles/SessionCheck.css";
 
const SessionCheck = (props) => {
 
    console.log('session check')
    const { token } = useProfile();
    const user = useSelector((state) => state.Login.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isSessionExpired, setSessionExpired] = useState(false);
 
    useEffect(() => {
        if (!token) return;
 
        const checkTokenExpiration = () => {
            const loggedInUser = getTokenValue(token);
            console.log('loggedInUser...',loggedInUser.exp)
            if (loggedInUser?.exp && Date.now() > loggedInUser.exp * 1000) {
                console.log('loggedInUser inside')
                setSessionExpired(true);
                localStorage.removeItem("authUser");
            } else {
                console.log('loggedInUser else part')
 
                setSessionExpired(false);
            }
        };
 
        checkTokenExpiration();
        const intervalId = setInterval(checkTokenExpiration, 30 * 1000);  
 
        return () => clearInterval(intervalId);
    }, [token]);
 
    useEffect(() => {
        if (!token || Object.keys(user).length !== 0) return;
        dispatch(getUser());
    }, [token, user, dispatch]);  
 
    const handleButtonClick = () => {
        navigate("/auth/signup");
        setSessionExpired(false);
    };

    return (
        <div>
            {isSessionExpired ? (
                <div className="session-main">
                    <div className="session-content card text-center">
                        <p>Session has expired. Please log in again.</p>
                        <Button className="session-btn bg-primary mt-3" onClick={handleButtonClick}>Login</Button>
                    </div>
                </div>
            ) : (
                <>{props.children}</>
            )}
        </div>
    )
}
export default SessionCheck;